import { compactMoney } from "@/lib/format";

const svg = (paths) =>
  `<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">${paths}</svg>`;

const ICONS = {
  Navy: svg('<path d="M12 22V8"/><path d="M5 12H2a10 10 0 0 0 20 0h-3"/><circle cx="12" cy="5" r="3"/>'),
  "Air Force": svg('<path d="M17.8 19.2 16 11l3.5-3.5C21 6 21.5 4 21 3c-1-.5-3 0-4.5 1.5L13 8 4.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>'),
  Army: svg('<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>'),
  Joint: svg('<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>'),
  "Coast Guard": svg('<circle cx="12" cy="12" r="10"/><path d="m4.93 4.93 4.24 4.24"/><path d="m14.83 9.17 4.24-4.24"/><path d="m14.83 14.83 4.24 4.24"/><path d="m9.17 14.83-4.24 4.24"/><circle cx="12" cy="12" r="4"/>'),
  DLA: svg('<path d="M11 21.73a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73z"/><path d="M12 22V12"/><path d="m3.3 7 8.7 5 8.7-5"/>'),
  shipyard: svg('<path d="M12 10.189V14"/><path d="M12 2v3"/><path d="M19 13V7a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v6"/><path d="M19.38 20A11.6 11.6 0 0 0 21 14l-8.188-3.639a2 2 0 0 0-1.624 0L3 14a11.6 11.6 0 0 0 2.81 7.76"/><path d="M2 21c.6.5 1.2 1 2.5 1 2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1s1.2 1 2.5 1c2.5 0 2.5-2 5-2 1.3 0 1.9.5 2.5 1"/>'),
};

export const baseIcon = (base) => (base.kind === "shipyard" ? ICONS.shipyard : ICONS[base.branch] || ICONS.Navy);

const esc = (s) => String(s).replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));

export function createBaseEl(base, onClick, showLabel = true) {
  const el = document.createElement("div");
  el.className = `base-pin${base.kind === "shipyard" ? " is-shipyard" : ""}`;
  el.dataset.testid = `map-base-${base.id}`;
  el.title = base.name;
  el.innerHTML = `<span class="dot">${baseIcon(base)}</span>${showLabel ? `<span class="lbl">${esc(base.short)}</span>` : ""}`;
  el.addEventListener("click", (e) => {
    e.stopPropagation();
    onClick?.();
  });
  return el;
}

export function createPriceEl(listing, onClick) {
  const el = document.createElement("button");
  el.type = "button";
  el.className = "price-pin";
  el.dataset.testid = `map-pin-${listing.listing_key}`;
  el.textContent = compactMoney(listing.price);
  el.setAttribute("aria-label", `${listing.title} ${compactMoney(listing.price)}`);
  el.addEventListener("click", (e) => {
    e.stopPropagation();
    onClick?.();
  });
  return el;
}

export function createOfficeEl() {
  const el = document.createElement("div");
  el.className = "office-pin";
  el.dataset.testid = "map-office-pin";
  el.title = "757 Realty office";
  el.textContent = "757";
  return el;
}
